import React from "react";
import { connect } from "react-redux";
import { useForm } from "react-hook-form";
import cleanDeep from "clean-deep";
import OvertimeRow from "../../../company-settings/overtime-tab/OvertimeRow";
import { Actions as OVERTIME_ACTIONS } from "@/redux/actions/overtimeActions";
import { PlusIcon, TrashIcon } from "@heroicons/react/20/solid";
import { NotificationManager } from "react-notifications";
import Select from "react-select";
import { useEffect, useState } from "react";

const Overtimes = ({
	existingCompanyDetails,
	updateCompanyDetails,
	addOvertime,
	nextPage,
	prevPage,
	checkedOvertime,
	disabled,
	advisor,
	templateOptions,
	selectedTemplate,
	applyTemplate,
	templateOvertimes,
	advisoryOvertimes,
	clearOvertimes,
}) => {
	const { org, overtimes } = existingCompanyDetails;

	const { handleSubmit } = useForm();

	const onSubmit = () => {
		let validation = overtimes.every((overtime) => typeof overtime.isToil !== "undefined");

		if (!validation) {
			NotificationManager.error("Please make sure all Overtime Types are selected", "Saving Company Details");
			return;
		}

		updateCompanyDetails(
			cleanDeep({ org: org, overtimes }, { emptyStrings: false, emptyArrays: false, emptyObjects: false }),
		);
		nextPage();
	};

	useEffect(() => {
		if (!selectedTemplate) return;

		templateOvertimes?.map((o) => {
			if (overtimes.find((ot) => ot?.id == o?.value)) return;
			addOvertime(o?.value);
		});
	}, [selectedTemplate]);

	return (
		<div>
			<form onSubmit={handleSubmit(onSubmit)}>
				{advisor && templateOptions.length > 0 ? (
					<>
						<div className="col-xs-12 form-section">
							<div className="pull-left">
								<h4>Apply Template</h4>
							</div>
							<div className="col-xs-12 pl-0 pb-6">
								<div className="form-material">
									<div className="col-xs-3 pl-0 pull-left">
										<Select
											valueName="selected"
											options={templateOptions}
											value={templateOptions.find((t) => t.value == selectedTemplate)}
											isDisabled={overtimes?.length > 0}
											placeholder="Choose one"
											onChange={(e) => {
												applyTemplate(e.value);
											}}
										/>
									</div>
									<div className="col-xs-3 pl-0 pull-left">
										<button
											className="btn btn-danger"
											type="button"
											onClick={() => {
												clearOvertimes();
												applyTemplate(null);
											}}
										>
											<TrashIcon style={{ height: "1.5em", float: "left" }} />
										</button>
									</div>
								</div>
							</div>
						</div>
					</>
				) : null}
				<div className="col-xs-12 form-section">
					<div className="pull-left">
						<h4>Overtime & Special Rates</h4>
					</div>
					{!disabled && (
						<button
							className="btn btn-success pull-right"
							type="button"
							onClick={() => {
								addOvertime();
							}}
						>
							<PlusIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
							<div style={{ float: "left" }}>Add Rate</div>
						</button>
					)}
					<div className="col-xs-12">
						<label className="css-input switch switch-sm switch-success">
							<input
								type="checkbox"
								checked={overtimes.find((overtime) => overtime.rate == 1.5)}
								onChange={(e) => checkedOvertime(e.target.checked, 1.5)}
							/>
							<span />
							Include overtime @ 1.5?
						</label>
						<label className="css-input switch switch-sm switch-success">
							<input
								type="checkbox"
								checked={overtimes.find((overtime) => overtime.rate == 2)}
								onChange={(e) => checkedOvertime(e.target.checked, 2)}
							/>
							<span />
							Include overtime @ 2?
						</label>
					</div>
					<div
						className="col-xs-12"
						style={{ marginBottom: 15 }}
					>
						<>
							{overtimes?.map((overtime) => {
								var fromTemplate = false;

								if (
									advisor &&
									selectedTemplate &&
									!overtime?.fromCheckbox &&
									templateOvertimes?.find((t) => t.value == overtime.id)
								) {
									overtime = advisoryOvertimes.find((o) => o.id == overtime.id);
									fromTemplate = true;
								}
								if (!overtime?.fromCheckbox)
									return (
										<OvertimeRow
											key={overtime.id}
											overtime={overtime}
											forModal={true}
											template={fromTemplate}
										/>
									);
							})}
						</>
					</div>
				</div>

				<div style={{ marginTop: 10 }}>
					<a
						href="#"
						className="btn btn-default"
						onClick={prevPage}
					>
						Back
					</a>
					<button
						className="btn btn-success right"
						type="submit"
					>
						Save
					</button>
				</div>
				<div className="clearfix" />
			</form>
		</div>
	);
};

const mapStateToProps = (state) => {
	const advisoryOvertimes = state?.advisors?.settings?.overtimes || [];
	const templates = state?.advisors?.settings?.templates || [];
	const selectedTemplate = state.company?.newCompany?.selectedOvertimeTemplate;

	const templateOptions = templates
		?.filter((t) => t.overtimes && t.overtimes.length > 0)
		.map((t) => ({ label: t?.name, value: t?.id }));

	const templateOvertimes = templates?.find((t) => t.id == selectedTemplate)?.overtimes;

	return {
		existingCompanyDetails: state.company.newCompany,
		advisor: state.company?.newCompany?.advisor,
		templateOptions,
		selectedTemplate,
		templateOvertimes,
		advisoryOvertimes,
	};
};

const mapDispatchToProps = (dispatch) => ({
	checkedOvertime: (rateChecked, rate) => dispatch(OVERTIME_ACTIONS.checkedOvertime(rateChecked, rate)),
	applyTemplate: (template) => dispatch(OVERTIME_ACTIONS.overtimeApplyTemplate(template)),
	clearOvertimes: () => dispatch(OVERTIME_ACTIONS.clearOvertime(true)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Overtimes);
